import React from 'react';
import { TableCell } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CustomPagination } from 'components';

const useStyles = makeStyles(theme => ({
    row: {
        fontSize: 16,
        textAlign: 'center',
        padding: 0,
    },
}));

const CustomTablePagination = ({ columns, currentPage, lastPage, changePage, loading }) => {
    const classes = useStyles();

    return (
        <TableCell colSpan={columns} className={classes.row}>
            <CustomPagination
                loading={loading}
                currentPage={currentPage}
                lastPage={lastPage}
                changePage={changePage}
            />
        </TableCell>
    );
};

export default CustomTablePagination;
